import type { FeatureFlagService } from "../../services/feature-flags";
import { normalizeOrders } from "./normalization";
import type { NormalizedOrders, NormalizeOrdersOptions } from "./normalization";
import type { OrdersParseTree } from "./parser";

export interface NormalizationDisabled {
  readonly error: {
    readonly code: "FEATURE_DISABLED";
    readonly message: string;
  };
  readonly ok: false;
}

export interface NormalizationSuccess {
  readonly ok: true;
  readonly value: NormalizedOrders;
}

export type GatedNormalizationResult =
  | NormalizationDisabled
  | NormalizationSuccess;

export function normalizeOrdersWhenEnabled(
  tree: OrdersParseTree,
  flags: FeatureFlagService,
  options: NormalizeOrdersOptions = {},
): GatedNormalizationResult {
  if (!flags.isEnabled("speechNormalization")) {
    return {
      ok: false,
      error: {
        code: "FEATURE_DISABLED",
        message: "Orders speech normalization is disabled in this build.",
      },
    };
  }
  return { ok: true, value: normalizeOrders(tree, options) };
}
